import React, { Component } from 'react';
import Layout from '../Layout';
import {Helmet} from "react-helmet";
// import { DOMAIN_NAME_API } from '../../Constants'
import AddClient from './AddClient2';

// import axios from 'axios'
// import moment from 'moment'
// eslint-disable-next-line
// import ru from 'moment/locale/ru'

import * as localeRU from './locale_ru.json'
import * as localeEN from './locale_en.json'
const locale = {
    "ru":localeRU.default,
    "en":localeEN.default
  }

class NewClientPage extends Component {
  constructor(props) {
      super(props);
      this.state = {
        clients: [],
        loaded: false
      };
  }
  componentDidMount() {
    // axios.defaults.headers.common['token'] = localStorage.getItem('token');

  }
  render() {
    let helmetTitle = 'Новый клиент - CRM Фабрика Фурнитуры';
    const selectedLanguage = localStorage.getItem('lang');
    const interfaceLocale = locale[selectedLanguage];
    return (
      <Layout match={this.props.match} history={this.props.history}>
        <Helmet>
          <title>{helmetTitle}</title>
        </Helmet>
        <div className="col-md-12" style={{minHeight: 15+'rem'}}>
          <AddClient locale={interfaceLocale} match={this.props.match} history={this.props.history} />
        </div>
      </Layout>
    );
  }
}

export default NewClientPage;
